import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { TrackingStatus } from '../../../enums/tracking-status';
import { getMessageDescriptor } from '../../../enums/external-fulfillment-status';

import Global from '../../../store/global-selectors';
import { messages } from '../messages';

export const getStatusText = ({ isVoided, trackingStatus, errorMessage, isVoidRequested, externalFulfillmentStatus }) => {
  if (isVoided) {
    return messages.cancelled;
  }

  if (trackingStatus === TrackingStatus.Delivered) {
    return messages.delivered;
  }

  if (errorMessage) {
    return messages.error;
  }

  if (trackingStatus === TrackingStatus.Shipped) {
    return messages.shipped;
  }

  if (isVoidRequested) {
    return messages.pendingCancellation;
  }

  if (externalFulfillmentStatus) {
    return getMessageDescriptor(externalFulfillmentStatus) || null;
  }

  return messages.submitted;
};

const Status = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId }));

  const message = getStatusText({
    isVoided: fulfillment?.externalFulfillment?.isVoided,
    trackingStatus: fulfillment?.trackingInformation?.status,
    errorMessage: fulfillment?.externalFulfillment?.externalFulfillmentError,
    isVoidRequested: fulfillment?.externalFulfillment?.isVoidRequested,
    externalFulfillmentStatus: fulfillment?.externalFulfillment?.externalFulfillmentStatus,
  });

  return message ? <FormattedMessage {...message} /> : '';
};

Status.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const status = {
  getMessageDescriptor: () => messages.status,
  name: <FormattedMessage {...messages.status} />,
  id: 'status',

  render: (data) => {
    if (data.isUpdating) {
      return <LoadingIndicator />;
    }
    return <Status fulfillmentId={data.id} />;
  },
};
